// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"w8","contentFrame":"w9","buttonGroup":"w-","button":"w_","header":"xa","text":"xb","contentImage":"xc","closeButton":"xd"};